import React from 'react';

import { CloudIcon } from 'components/Icons';
import { BlueprintDetailCard } from 'containers/PolicyHub/Blueprints/Components/Blueprint/Details/Cards/BlueprintDetailCard';

export const BlueprintClouds: React.FC = () => {
  return <BlueprintDetailCard icon={<CloudIcon />} label="Clouds" />;
};
